// extracted by mini-css-extract-plugin
module.exports = {"Admin":"Admin_Admin__3ozxY"};